import { useState } from "react"
import { Box, Button, DialogActions, DialogContent, DialogTitle, Stack, TextField } from "@mui/material"
import { setFromEvent } from "lib/setFromEvent"
import Iconify from "minimals-template/components/Iconify"

export function ConfirmDialogWithUserInput({ confirmValue, message, title, ok, cancel, buttons, startIcon }) {
    const [value, setValue] = useState("")
    return (
        <>
            {title && (
                <DialogTitle>
                    <Box display="flex" alignItems="center">
                        {startIcon !== "" && (
                            <Box sx={{ display: "flex", alignItems: "center", mr: 1 }}>
                                <Iconify sx={{ width: 30, height: 30 }} icon={startIcon} />
                            </Box>
                        )}
                        <Box>{title}</Box>
                    </Box>
                </DialogTitle>
            )}

            <DialogContent sx={{ mt: 2 }}>
                <Stack spacing={2}>
                    <Box mb={2}>{message}</Box>
                    <TextField
                        data-cy="user-input-confirm"
                        autoFocus
                        value={value}
                        onChange={setFromEvent(setValue)}
                        placeholder={confirmValue}
                        label={`Type "${confirmValue}" to confirm`}
                    />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={cancel} color="secondary">
                    Cancel
                </Button>
                {buttons ? (
                    buttons.map((b) => (
                        <Button key={b} onClick={() => ok(b)} color="primary">
                            {b}
                        </Button>
                    ))
                ) : (
                    <Button
                        disabled={value !== `${confirmValue}`}
                        onClick={() => ok(true)}
                        color="primary"
                        variant="contained"
                        id="confirmOkButton"
                        data-cy="dialogActionsOkButton"
                    >
                        Ok
                    </Button>
                )}
            </DialogActions>
        </>
    )
}
